function _extends() {
  _extends =
    Object.assign ||
    function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

import React, { useMemo } from "react";
import { register, Registry } from "@diana-ui/registry";

var camelToKebab = input => {
  return input.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
};

var Icon = _ref => {
  var { name, height, width, stroke, fill, color, src, size, cx } = _ref,
    props = _objectWithoutProperties(_ref, [
      "name",
      "height",
      "width",
      "stroke",
      "fill",
      "color",
      "src",
      "size",
      "cx"
    ]);

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  var themeIcons = Registry.get("ThemeIcons"); // eslint-disable-next-line @typescript-eslint/no-explicit-any

  var SvgIcon = useMemo(() => {
    var match = Object.keys(themeIcons).find(
      key => key.toLowerCase() === name.toLowerCase() || camelToKebab(key) === name.toLowerCase()
    );
    return src || (match && themeIcons[match]) || "";
  }, [name, src, themeIcons]); // Building props this way to avoid override svg previous values, only if specified.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any

  var newProps = {};

  if (size || width) {
    newProps.width = size || width;
  }

  if (size || height) {
    newProps.height = size || height;
  }

  if (fill || color) {
    newProps.fill = fill || color;
  }

  if (stroke) {
    newProps.stroke = stroke;
  }

  return /*#__PURE__*/ React.createElement(SvgIcon, _extends({}, props, newProps));
};

Icon.displayName = "Icon";
register(Icon);
export default Icon;
